import { useEffect, useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { Tabs, Tab, Box, Typography, Tooltip } from "@mui/material";
import { format, startOfWeek, endOfWeek, } from 'date-fns';
import localeMap from "../crud/locales";
import './Calendar.css';
import { ReactComponent as LeftArrow } from 'bootstrap-icons/icons/arrow-left.svg';
import { ReactComponent as RightArrow } from 'bootstrap-icons/icons/arrow-right.svg';
import WeekView from "./WeekView";
import DayView from "./DayView";
import { ErrorAlert, getCultureInfo, getIsoWeekStartOf, getisoWeekEndOf, getIsoMonthStartOf, getisoStartDate, getisoEndDate } from '../crud/utils';
import useApp from '../AppContext';
import { loadListAllObjects, loadDataObject, getIsHoliday, putBooking, DeleteBooking } from "./CalendarUtils";
import NewBookingForm from "./NewBookingForm";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CustomSelect from "../Components/CustomSelect";
import { useWebSocket } from "../WebSocketContext";
import { t } from './../i18n';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import ToastNotifications from "../Components/ToastNotifications";
import ScheduleBookingForm from './ScheduledBookingForm'

function CalendarBooking(props) {
    const app = useApp();
    const [serverUrl] = useState(app.serverUrl);
    const [userid] = useState(app.sessionToken?.UserId);
    const [User3pl] = useState(app.sessionToken?.User3pl);
    // const [SupplierId] = useState(app.sessionToken?.SupplierId);    
    const [language] = useState(getCultureInfo(app.sessionToken?.Language));
    const [error, setError] = useState(null);
    const [data, setData] = useState({});
    const [view, setView] = useState("day");
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingDeleteId, setPendingDeleteId] = useState(null);


    const [allColumnsObj, setAllColumnsObj] = useState({});
    const [defaultwarehouseId, setDefaultwarehouseId] = useState(null);
    const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [isLoadObj, setIsLoadObj] = useState(false);

    const [selectTtimeSlot, setSelectTtimeSlot] = useState([]);
    const [isHoliday, setIsHoliday] = useState(false);
    const [actions, setActions] = useState(null);
    const [bookingId, setBookingId] = useState(null);
    const [actionRefresh, setActionRefresh] = useState(false);
    const [errorMessageFromSave, setErrorMessageFromSave] = useState(null);
    const [openDatePicker, setOpenDatePicker] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [availableCategories, setAvailableCategories] = useState({});
    const [processingBookings, setProcessingBookings] = useState(new Set());

    const refreshCallBack = useCallback(() => {
        setActionRefresh(prev => !prev);
    }, []);

    const ws = useWebSocket();
    useEffect(() => {
        if (!ws) return;
        const handler = (event) => {
            try {
                //  const msg = JSON.parse(event);
                if (event?.type === "refreshdata") {
                    console.log("Received from server:", event);
                    refreshCallBack();
                    //   alert("Received countUpdated: " + event?.data);
                }
            } catch (e) {
                // handle non-JSON or unexpected messages
            }
        };
        ws.on("refreshdata", handler);
        return () =>
            ws.off("refreshdata", handler);
    }, [ws, refreshCallBack]);

    useEffect(() => {
        async function getDefaultLayouts() {
            if (!serverUrl) return;
            if (!allColumnsObj || (Object.keys(allColumnsObj).length === 0)) {
                let allobj = await loadListAllObjects(serverUrl, props.userToken)
                setAllColumnsObj(allobj);
                setIsLoadObj(true);
            }
        }
        getDefaultLayouts();
    }, [serverUrl, props.userToken, allColumnsObj]);



    useEffect(() => {
        async function get3plSuppliers() {
            if (!userid) return;
            if (!User3pl) return;
            const objectName = "Yms_3plSuppliers";
            if (Object.keys(allColumnsObj).length === 0) return;
            let prms = [];
            let prmValues = {};
            let defaultVariables = {
                "filterName": "customfilter",
                "top": 50
            }
            defaultVariables["appendFilter"] = "{Yms3su.Yms3plId} =?(;n;5;p_User3pl)";
            prms.push({ "parameterName": "p_User3pl", "type": "" });
            prmValues["p_User3pl"] = User3pl;
            const responseObj = await loadDataObject(serverUrl, props.userToken, objectName, allColumnsObj, prms, prmValues, defaultVariables);
            setData(prev => {
                prev = { ...prev };
                prev[objectName] = responseObj
                return prev;
            });
        }
        get3plSuppliers();
    }, [serverUrl, props.userToken, allColumnsObj, User3pl, userid]);



    useEffect(() => {
        async function getWarehouses() {
            if (!userid) return;
            const objectName = "Yms_Warehouses";
            if (Object.keys(allColumnsObj).length === 0) return;
            let prms = [];
            let prmValues = {};
            let defaultVariables = {
                "filterName": "customfilter"
            }
            if (app.sessionToken?.Role === 'Admin') {
                if (app.sessionToken?.WarehouseId === null || app.sessionToken?.WarehouseId === '') {
                    defaultVariables["appendFilter"] = "{WarehouseId} IN (SELECT WAREHOUSEID FROM YMS_USERSWAREHOUSES WHERE USERID = ?(;n;5;p_UserId) AND ACTIVEFLG=1)";
                    prms.push({ "parameterName": "p_UserId", "type": "" });
                    prmValues["p_UserId"] = userid;
                }
                else {
                    defaultVariables["appendFilter"] = "{WarehouseId} =?(;n;5;p_WarehouseId)";
                    prms.push({ "parameterName": "p_WarehouseId", "type": "" });
                    prmValues["p_WarehouseId"] = app.sessionToken.WarehouseId;
                }
            }
            const responseObj = await loadDataObject(serverUrl, props.userToken, objectName, allColumnsObj, prms, prmValues, defaultVariables);
            setData(prev => {
                prev = { ...prev };
                prev[objectName] = responseObj
                return prev;
            });
        }
        getWarehouses();
    }, [userid, allColumnsObj, serverUrl, app.sessionToken, props.userToken]);

    useEffect(() => {
        async function getCategories() {
            if (!userid) return;
            const objectName = "Yms_Categories";
            if (Object.keys(allColumnsObj).length === 0) return;
            let prms = [];
            let prmValues = {};
            let defaultVariables = {
                "filterName": "customfilter",
            }
            const responseObj = await loadDataObject(serverUrl, props.userToken, objectName, allColumnsObj, prms, prmValues, defaultVariables);
            setData(prev => {
                prev = { ...prev };
                prev[objectName] = responseObj
                return prev;
            });
        }
        getCategories();
    }, [userid, allColumnsObj, serverUrl, props.userToken]);

    useEffect(() => {
        async function getYmsBooking() {
            if (!userid || !selectedWarehouseId || !currentDate) return;
            if (!userid) return;
            if (!selectedWarehouseId) return;
            if (!currentDate) return;
            const objectName = "Yms_Booking";
            if (Object.keys(allColumnsObj).length === 0) return;
            const holiday = await getIsHoliday(serverUrl, props.userToken, currentDate)
            setIsHoliday(holiday);

            let defaultVariables = {
                "filterName": "customfilter"
            }
            let prms = [];
            let prmValues = {};
            defaultVariables["appendFilter"] = "{YmsBok.WarehouseId} =?(;n;5;p_WarehouseId) AND {YmsBok.FromDate} >= ?(;d;;p_FromDate) AND {YmsBok.FromDate} < ?(;d;;p_ToDate)";
            defaultVariables["appendFilter"] = defaultVariables["appendFilter"] +
                " AND EXISTS (SELECT YMSBTA.BOOKINGID " +
                " FROM YMS_BOOKINGTASKS YMSBTA," +
                "  YMS_TASKS YMSTAS, " +
                "     YMS_ZONES YMSZON " +
                " WHERE YMSTAS.TASKID = YMSBTA.TASKID " +
                " AND YMSZON.ZONEID = YMSTAS.ZONEID " +
                " AND YMSZON.CAPACITYFLG =1 " +
                " AND YMSBOK.BOOKINGID = YMSBTA.BOOKINGID)";

            if (selectedCategory) {
                defaultVariables["appendFilter"] = defaultVariables["appendFilter"] +
                    " AND EXISTS (SELECT 1 FROM YMS_BOOKINGTASKS YMSBTA2, YMS_CATEGORIES YMSCAT " +
                    " WHERE YMSBTA2.CATEGORYID = YMSCAT.CATEGORYID " +
                    " AND YMSCAT.DESCR1 = ?(;s;;p_CategoryName) " +
                    " AND YMSBOK.BOOKINGID = YMSBTA2.BOOKINGID)";
                prms.push({ "parameterName": "p_CategoryName", "type": "" });
                prmValues["p_CategoryName"] = selectedCategory;
            }

            prms.push({ "parameterName": "p_WarehouseId", "type": "" });
            prmValues["p_WarehouseId"] = selectedWarehouseId;
            prms.push({ "parameterName": "p_FromDate", "type": "" });
            prms.push({ "parameterName": "p_ToDate", "type": "" });
            if (view === "week") {
                const fromdate = getIsoWeekStartOf(currentDate);
                const endOfDay = getisoWeekEndOf(currentDate);
                prmValues["p_FromDate"] = format(getisoStartDate(fromdate), "yyyy-MM-dd'T'HH:mm");
                prmValues["p_ToDate"] = format(getisoEndDate(endOfDay), "yyyy-MM-dd'T'HH:mm");
            }
            else if (view === "day") {
                prmValues["p_FromDate"] = format(getisoStartDate(currentDate), "yyyy-MM-dd'T'00:00");
                prmValues["p_ToDate"] = format(getisoEndDate(currentDate), "yyyy-MM-dd'T'HH:mm");
            }
            const objectData = await loadDataObject(serverUrl, props.userToken, objectName, allColumnsObj, prms, prmValues, defaultVariables);
            if (objectData) {
                const sortedData = [...objectData].sort((a, b) => {
                    const idA = Number(a.BookingId) || 0;
                    const idB = Number(b.BookingId) || 0;
                    return idA - idB;
                });
                setData(prev => ({
                    ...prev,
                    [objectName]: sortedData,
                }));
            }
            // console.log(objectData);
        }
        getYmsBooking();
    }, [userid, actionRefresh, selectedWarehouseId, currentDate, view, allColumnsObj, serverUrl, app.sessionToken, props.userToken, selectedCategory]);

    useEffect(() => {
        async function getYmsBookingTasks() {
            if (!selectedWarehouseId) return;
            if (!allColumnsObj || (Object.keys(allColumnsObj).length === 0)) return;

            const objectName = "Yms_BookingTasks";
            let defaultVariables = {
                "filterName": "customfilter",
                "instanceName": "m_yms_booking",
            }
            let prms = [];
            let prmValues = {};

            defaultVariables["appendFilter"] = "EXISTS (SELECT 1 FROM YMS_BOOKING YB WHERE YB.BOOKINGID = YmsBta.BOOKINGID AND YB.WarehouseId = ?(;n;5;p_WarehouseId) AND YB.FromDate >= ?(;d;;p_FromDate) AND YB.FromDate < ?(;d;;p_ToDate))";

            prms.push({ "parameterName": "p_WarehouseId", "type": "" });
            prmValues["p_WarehouseId"] = selectedWarehouseId;
            prms.push({ "parameterName": "p_FromDate", "type": "" });
            prms.push({ "parameterName": "p_ToDate", "type": "" });

            if (view === "week") {
                const fromdate = getIsoWeekStartOf(currentDate);
                const endOfDay = getisoWeekEndOf(currentDate);
                prmValues["p_FromDate"] = format(getisoStartDate(fromdate), "yyyy-MM-dd'T'HH:mm");
                prmValues["p_ToDate"] = format(getisoEndDate(endOfDay), "yyyy-MM-dd'T'HH:mm");
            }
            else if (view === "day") {
                prmValues["p_FromDate"] = format(getisoStartDate(currentDate), "yyyy-MM-dd'T'00:00");
                prmValues["p_ToDate"] = format(getisoEndDate(currentDate), "yyyy-MM-dd'T'HH:mm");
            }

            const objectData = await loadDataObject(serverUrl, props.userToken, objectName, allColumnsObj, prms, prmValues, defaultVariables);
            if (objectData) {
                setData(prev => {
                    prev = { ...prev };
                    prev[objectName] = objectData;
                    return prev;
                });
            }
        }
        getYmsBookingTasks();
    }, [userid, actionRefresh, selectedWarehouseId, currentDate, view, allColumnsObj, serverUrl, app.sessionToken, props.userToken]);

    useEffect(() => {
        if (!selectedWarehouseId && data["Yms_Warehouses"]?.length > 0) {
            setSelectedWarehouseId(data["Yms_Warehouses"][0].WarehouseId);
        }
    }, [selectedWarehouseId, data]);
    const statusColors = {
        1: {
            dotColor: "#ebb917",
            statusColor: "#ebb917",
            bgColor: "#FEF3C7",
            statusName: (t('StatusDescr.pending', language))
        },
        2: {
            dotColor: "#20c997",
            statusColor: "#20c997",
            bgColor: "#E0F7FA",
            statusName: (t('StatusDescr.change', language))
        },
        3: {
            dotColor: "#6B7280",
            statusColor: "#374151",
            bgColor: "#F3F4F6",
            statusName: (t('StatusDescr.preliminarDetention', language))
        },
        4: {
            dotColor: "#B91C1C",
            statusColor: "#B91C1C",
            bgColor: "#FEE2E2",
            statusName: (t('StatusDescr.canceled', language))
        },
        5: {
            dotColor: "#047857",
            statusColor: "#047857",
            bgColor: "#D1FAE5",
            statusName: (t('StatusDescr.accepted', language))
        },
        6: {
            dotColor: "#2596FF",
            statusColor: "#2596FF",
            bgColor: "#F0F8FF",
            statusName: (t('StatusDescr.arrived', language))
        },
        7: {
            dotColor: "#14AE5C",
            statusColor: "#14AE5C",
            bgColor: "#DEF7EC",
            statusName: (t('StatusDescr.loading', language))
        },
        8: {
            dotColor: "#8D97B0",
            statusColor: "#8D97B0",
            bgColor: "#F5F5F5",
            statusName: (t('StatusDescr.finished', language))
        },
        default: {
            dotColor: "#374151",
            statusColor: "#374151",
            bgColor: "#E5E7EB",
            statusName: (t('StatusDescr.default', language))
        }
    };
    const getEventColors = (status) => statusColors[status] || statusColors.default;
    const handleDayClick = (day) => {
        setSelectedDate(format("YYYY-MM-DD"));
    };

    const handleViewChange = (event, newValue) => {
        setView(newValue);
    };
    const handlePrevMonth = () => {
        let ddate = new Date(currentDate)

        if (view === "month") {
            setCurrentDate(currentDate.subtract(1, "month"));
        } else if (view === "week") {
            ddate.setDate(currentDate.getDate() - 7);
            setCurrentDate(ddate);
        } else if (view === "day") {
            ddate.setDate(currentDate.getDate() - 1);
            setCurrentDate(ddate);
        }
    };
    const handleNextMonth = () => {
        let ddate = new Date(currentDate)
        if (view === "month") {
            setCurrentDate(currentDate.add(1, "month"));
        } else if (view === "week") {
            ddate.setDate(currentDate.getDate() + 7);
            setCurrentDate(ddate);
        } else if (view === "day") {
            ddate.setDate(currentDate.getDate() + 1);
            setCurrentDate(ddate);
        }
    };
    const handleGoToCurrent = () => {
        if (view === "month") {
            setCurrentDate(getIsoMonthStartOf(new Date()));
        } else if (view === "week") {
            setCurrentDate(getIsoWeekStartOf(new Date()));
        } else if (view === "day") {
            setCurrentDate(new Date());
        }
    };

    const dropDowSelectChange = (newWarehouseId) => {
        setSelectedWarehouseId(Number(newWarehouseId));
    };

    async function handContextMenu(action, bookingid, slotTime, errorMessage) {
        // "New"
        // "Scheduled"
        //"Edit"
        //"Delete"
        //Accepted
        // props.onDelete?.(props.event);

        if (action === "New") {
            setSelectTtimeSlot(slotTime);
            setActions('NewBoocking');
            setBookingId('0');
            setIsModalOpen(true);
        }
        else if (action === "Scheduled") {
            setSelectTtimeSlot(slotTime);
            setActions('ScheduledBooking');
            setIsModalOpenScheduled(true);
        }
        else if (action === "Edit" && bookingid !== null) {
            setActions('EditBoocking');
            setBookingId(bookingid);
            setIsModalOpen(true);
        }
        else if (action === "Delete" && bookingid !== null) {
            setPendingDeleteId(bookingid);
            setShowConfirmModal(true);
        }
        else if (action === "Accepted" && bookingid !== null) {
            if (processingBookings.has(bookingid)) {
                return;
            }

            setProcessingBookings(prev => new Set(prev).add(bookingid));

            try {
                let bookingObj = {
                    Obj: { "BookingId": bookingid, "Status": 5, "PlannerUserId": userid }
                }
                const saveobj = await putBooking(serverUrl, props.userToken, "Yms_Booking", "m_yms_booking", bookingObj);
                if (saveobj) {
                    let tmpMsgError = null
                    if (saveobj?.ErrorMessage) {
                        tmpMsgError = "ArrivalId:" + saveobj?.ArrivalId + ", " + saveobj?.ErrorMessage
                    }
                    setErrorMessageFromSave(tmpMsgError);
                    setActions(null);
                    setBookingId(null);
                    setIsModalOpen(false);
                    refreshCallBack();
                }
            } finally {
                setProcessingBookings(prev => {
                    const newSet = new Set(prev);
                    newSet.delete(bookingid);
                    return newSet;
                });
            }
        }
        else if (action === "cancel" && bookingid !== null) {
            if (processingBookings.has(bookingid)) {
                return;
            }

            setProcessingBookings(prev => new Set(prev).add(bookingid));

            try {
                let bookingObj = {
                    Obj: { "BookingId": bookingid, "Status": 4 }
                }
                const saveobj = await putBooking(serverUrl, props.userToken, "Yms_Booking", "m_yms_booking", bookingObj);
                if (saveobj) {
                    setActions(null);
                    setBookingId(null);
                    setIsModalOpen(false);
                    refreshCallBack();
                }
            } finally {
                setProcessingBookings(prev => {
                    const newSet = new Set(prev);
                    newSet.delete(bookingid);
                    return newSet;
                });
            }
        }

        else if (action === "Save") {
            setBookingId(null);
            setActions(null);
            if (errorMessage) {
                setErrorMessageFromSave(errorMessage);
            }
            refreshCallBack();

        }
    };

    const handleCategoryClick = (categoryName) => {
        setSelectedCategory(selectedCategory === categoryName ? null : categoryName);
    };

    const confirmDelete = async () => {
        if (!pendingDeleteId) return;

        let bookingObj = {
            Obj: { "BookingId": pendingDeleteId }
        };

        const saveobj = await DeleteBooking(serverUrl, props.userToken, "Yms_Booking", "m_yms_booking", bookingObj);
        if (saveobj) {
            setActions(null);
            setBookingId(null);
            setIsModalOpen(false);
            setShowConfirmModal(false);
            setPendingDeleteId(null);
            refreshCallBack();
        }
    };

    const cancelDelete = () => {
        setShowConfirmModal(false);
        setPendingDeleteId(null);
    };


    const handleCloseModal = () => {
        //    setActionRefresh(actions);
        setActiveTab(1)
        setIsModalOpen(false);
    };
    const handleCloseModalScheduled = () => {
        setIsModalOpenScheduled(false);
    };

    const renderCalendar = () => {
        if (view === "day") {
            return (
                <DayView
                    currentDate={currentDate}
                    serverUrl={serverUrl}
                    userid={userid}
                    data={data}
                    allColumnsObj={allColumnsObj}
                    warehouseid={selectedWarehouseId}
                    getEventColors={getEventColors}
                    handContextMenu={handContextMenu}
                    selectedEvent={selectedEvent}
                    userToken={props.userToken}
                    isHoliday={isHoliday}
                    userApp={app}
                    onCategoryClick={handleCategoryClick}
                    selectedCategory={selectedCategory}
                    onCategoriesUpdate={setAvailableCategories}
                    actionRefresh={actionRefresh}
                    errorMessageFromSave={errorMessageFromSave}
                    setErrorMessageFromSave={setErrorMessageFromSave}
                />
            );
        }
        else if (view === "week") {
            return (
                <WeekView
                    data={data}
                    allColumnsObj={allColumnsObj}
                    currentDate={currentDate}
                    selectedDate={selectedDate}
                    warehouseid={selectedWarehouseId}
                    handleDayClick={handleDayClick}
                    getEventColors={getEventColors}
                    setSelectedEvent={setSelectedEvent}
                    setCurrentDate={setCurrentDate}
                    setView={setView}
                    isHoliday={isHoliday}
                    userApp={app}
                />
            );
        }
    };
    useEffect(() => {
        async function getDefaultwarehouse() {
            if (app.sessionToken?.WarehouseId !== null && app.sessionToken.WarehouseId !== "") {
                setDefaultwarehouseId(app.sessionToken.WarehouseId);
                setSelectedWarehouseId(app.sessionToken.WarehouseId);
            }
        }
        getDefaultwarehouse();
    }, [app.sessionToken]);

    function CreateFilter() {
        let warehouses = (data["Yms_Warehouses"]) ? data["Yms_Warehouses"] : []
        if (warehouses.length === 0) return;
        // let readonly = false;
        // if (defaultwarehouseId !== null && defaultwarehouseId !== "") { readonly = true; }
        // if (selectedWarehouseId === null || selectedWarehouseId === "") { setSelectedWarehouseId(warehoyses[0].WarehouseId); }
        const readonly = defaultwarehouseId !== null && defaultwarehouseId !== "";
        const selectedWarehouse = warehouses.find(w => Number(w.WarehouseId) === Number(selectedWarehouseId));
        return (
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <div className="custom-select-wrapper">
                    <CustomSelect
                        options={warehouses.map(row => ({ value: row.WarehouseId, label: row.Descr1 }))}
                        value={selectedWarehouse?.WarehouseId || ""}
                        placeholder={selectedWarehouse?.Descr1 || t('truckJourney.selectWarehouse', language)}
                        onChange={dropDowSelectChange}
                        readonly={readonly}
                    />
                </div>

                <div className="custom-select-wrapper">
                    <CustomSelect
                        options={[
                            { value: '', label: t('common.allCategories', language) },
                            ...(data["Yms_Categories"] || [])
                                .filter(category => availableCategories[category.Descr1] > 0)
                                .map(category => ({
                                    value: category.Descr1,
                                    label: category.Descr1
                                }))
                        ]}
                        value={selectedCategory || ''}
                        onChange={(value) => {
                            setSelectedCategory(value === '' ? null : value);
                        }}
                        readonly={!(app.sessionToken?.Role === "Admin" || app.sessionToken?.Role === "Planner")}
                    />
                </div>
            </div>
        )
    }

    /* popup */
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenScheduled, setIsModalOpenScheduled] = useState(false);
    const [activeTab, setActiveTab] = useState(1);

    const handleNext = () => {
        setActiveTab(2);
    };

    const handlePrev = () => {
        setActiveTab(1);
    };
    /* popup */
    const warehouses = data["Yms_Warehouses"] ? data["Yms_Warehouses"] : [];

    if (!isLoadObj) return;
    return (
        <>
            <ErrorAlert message={error} setMessage={setError} language={language} />
            {warehouses.length === 0 ? (
                <div className="no-warehouse-message">
                    <img src="./images/NoWarehouse.png" alt="No warehouse" />
                    <h2>{t("bookingCalendar.noWarehouseTitle", language)}</h2>
                    <p>
                        {t("bookingCalendar.noWarehouseMessage", language)}
                    </p>
                </div>
            ) : (
                <Box
                    className="calendar-container"
                    style={{ height: '100%' }}
                >
                    <div className="calendar-options-container">
                        <div className="container-header-left">
                            <div className="calendar-container-pick">
                                {CreateFilter()}
                            </div>
                            <div className="calendar-options-current-back-next">
                                <Tooltip title={t('bookingCalendar.goToCurrent', language)} arrow>
                                    <div onClick={handleGoToCurrent} className="go-to-current"><i className="bi bi-clock"></i></div>
                                </Tooltip>
                                <div style={{ position: "relative" }}>
                                    <Typography
                                        style={{ minWidth: '385px', width: "100%", cursor: "pointer", fontSize: "25px", fontWeight: "500" }}
                                        onClick={() => setOpenDatePicker(true)}
                                    >
                                        {view === "day" &&
                                            format(currentDate, "EEEE, dd MMMM yyyy", {
                                                locale: localeMap[language] || localeMap["el"],
                                            })}

                                        {view === "week" && (() => {
                                            const weekStart = startOfWeek(currentDate, { weekStartsOn: 1 });
                                            const weekEnd = endOfWeek(currentDate, { weekStartsOn: 1 });
                                            return `${format(weekStart, "dd", { locale: localeMap[language] || localeMap["el"] })} – ${format(weekEnd, "dd MMMM yyyy", { locale: localeMap[language] || localeMap["el"] })}`;
                                        })()}

                                        {view === "month" &&
                                            format(currentDate, "MMMM yyyy", {
                                                locale: localeMap[language] || localeMap["el"],
                                            })}
                                    </Typography>
                                    {openDatePicker && (
                                        <div style={{ position: "absolute", zIndex: 15 }}>
                                            <DatePicker
                                                selected={currentDate}
                                                onChange={(date) => {
                                                    setCurrentDate(date);
                                                    setOpenDatePicker(false);
                                                }}
                                                onClickOutside={() => setOpenDatePicker(false)}
                                                inline
                                                locale={localeMap[language] || localeMap['el']}
                                            />
                                        </div>
                                    )}
                                </div>

                                <button onClick={handlePrevMonth}>
                                    <LeftArrow />
                                </button>
                                <button onClick={handleNextMonth}>
                                    <RightArrow />
                                </button>

                            </div>
                        </div>
                        <div className="calendar-options-day-week-month">
                            <Tabs
                                value={view}
                                onChange={handleViewChange}
                                variant="standard"
                                className="calendar-tabs"
                                TabIndicatorProps={{ style: { display: "none" } }}
                            >
                                <Tab
                                    label={(t('bookingCalendar.days', language))}
                                    value="day"
                                    className={`calendar-tab ${view === "day" ? "selected" : ""}`}
                                    icon={
                                        <svg
                                            width="35" height="35"
                                            viewBox="0 0 372 424"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{ display: 'block', marginBottom: "10px" }}
                                        >
                                            <g filter="url(#filter0_d_1380_240)">
                                                <path d="M13 133H385V401.667C385 413.081 375.747 422.333 364.333 422.333H33.6667C22.2528 422.333 13 413.081 13 401.667V133Z" fill="#F7F7F7" />
                                                <path d="M13 133H385V60.6667C385 49.2528 375.747 40 364.333 40H33.6667C22.2528 40 13 49.2528 13 60.6667V133Z" fill="var(--color-main-background)" />
                                                <rect x="49" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="100.667" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="152.333" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="204" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="255.667" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="307.333" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="49" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="100.667" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="152.333" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="204" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="255.667" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="307.333" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="49" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="100.667" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="152.333" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="204" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="255.667" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="307.333" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="49" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="100.667" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="152.333" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="204" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="255.667" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="307.333" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="64.667" y="9" width="20.6667" height="51.6667" rx="8" fill="#5C5C5C" />
                                                <rect x="95.667" y="9" width="20.6667" height="51.6667" rx="8" fill="#5C5C5C" />
                                                <rect x="281.667" y="9" width="20.6667" height="51.6667" rx="8" fill="#5C5C5C" />
                                                <rect x="312.667" y="9" width="20.6667" height="51.6667" rx="8" fill="#5C5C5C" />
                                            </g>
                                            <defs>
                                                <filter id="filter0_d_1380_240" x="0" y="0" width="398" height="439.333" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                    <feOffset dy="4" />
                                                    <feGaussianBlur stdDeviation="6.5" />
                                                    <feComposite in2="hardAlpha" operator="out" />
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1380_240" />
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1380_240" result="shape" />
                                                </filter>
                                            </defs>
                                        </svg>
                                    }
                                />

                                <Tab
                                    label={(t('bookingCalendar.week', language))}
                                    value="week"
                                    className={`calendar-tab ${view === "week" ? "selected" : ""}`}
                                    icon={
                                        <svg
                                            width="35" height="35"
                                            viewBox="0 0 372 424"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{ display: 'block', marginBottom: "10px" }}
                                        >
                                            <g filter="url(#filter0_d_1380_240)">
                                                <path d="M13 133H385V401.667C385 413.081 375.747 422.333 364.333 422.333H33.6667C22.2528 422.333 13 413.081 13 401.667V133Z" fill="#F7F7F7" />
                                                <path d="M13 133H385V60.6667C385 49.2528 375.747 40 364.333 40H33.6667C22.2528 40 13 49.2528 13 60.6667V133Z" fill="var(--color-main-background)" />
                                                <rect x="49" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="100.667" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="152.333" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="204" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="255.667" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="307.333" y="165.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="49" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="100.667" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="152.333" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="204" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="255.667" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="307.333" y="217.333" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="49" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="100.667" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="152.333" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="204" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="255.667" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="307.333" y="269" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="49" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="100.667" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="152.333" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="var(--color-main-background)" />
                                                <rect x="204" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="255.667" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="307.333" y="320.666" width="41.3333" height="41.3333" rx="5.16667" fill="#C0C0C0" />
                                                <rect x="64.667" y="9" width="20.6667" height="51.6667" rx="8" fill="#5C5C5C" />
                                                <rect x="95.667" y="9" width="20.6667" height="51.6667" rx="8" fill="#5C5C5C" />
                                                <rect x="281.667" y="9" width="20.6667" height="51.6667" rx="8" fill="#5C5C5C" />
                                                <rect x="312.667" y="9" width="20.6667" height="51.6667" rx="8" fill="#5C5C5C" />
                                            </g>
                                            <defs>
                                                <filter id="filter0_d_1380_240" x="0" y="0" width="398" height="439.333" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                    <feOffset dy="4" />
                                                    <feGaussianBlur stdDeviation="6.5" />
                                                    <feComposite in2="hardAlpha" operator="out" />
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1380_240" />
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1380_240" result="shape" />
                                                </filter>
                                            </defs>
                                        </svg>
                                    }
                                />
                            </Tabs>
                        </div>
                    </div>
                    <Box className='calendar-container-in-render'>{renderCalendar()}</Box>
                </Box>
            )}
            <Modal show={isModalOpen} onHide={handleCloseModal} size="lg" centered animation={true} backdrop="static">
                <Modal.Header closeButton className="border-0"></Modal.Header>
                <Modal.Body className="text-center" style={{ borderRadius: '22px' }}>
                    <NewBookingForm activeTab={activeTab}
                        actions={actions}
                        bookingId={bookingId}
                        warehouseid={selectedWarehouseId}
                        selectTtimeSlot={selectTtimeSlot}
                        isHoliday={isHoliday}
                        handleNext={handleNext}
                        handlePrev={handlePrev}
                        handleCloseModalOuter={handleCloseModal}
                        handContextMenu={handContextMenu}
                        userToken={props.userToken} />
                </Modal.Body>
            </Modal>
            <Modal show={isModalOpenScheduled} onHide={handleCloseModalScheduled} size="lg" centered animation={true} backdrop="static">
                <Modal.Header closeButton className="border-0"></Modal.Header>
                <Modal.Body className="text-center" style={{ borderRadius: '22px' }}>
                    <ScheduleBookingForm
                        setIsModalOpenScheduled={setIsModalOpenScheduled}
                        warehouseid={selectedWarehouseId}
                        userToken={props.userToken} data={data}
                        selectTtimeSlot={selectTtimeSlot} />
                </Modal.Body>
            </Modal>
            <Modal show={showConfirmModal} onHide={cancelDelete} centered animation={true} backdrop="static">
                <Modal.Header closeButton style={{ borderBottom: "unset !important" }}>
                </Modal.Header>
                <Modal.Body style={{ borderRadius: '22px' }}>
                    <div className="delete-modal-container">
                        <HighlightOffIcon />
                        <p className="fw-bold">{(t('bookingCalendar.deleteTitle', language))}</p>
                        <p className="text-danger">{(t('bookingCalendar.deleteDescr', language))}</p>
                        <div className="delete-btn-container">
                            <div className="confirm-load-btn-container">
                                <button className="modal-btn-primary-danger" onClick={confirmDelete}>
                                    {(t('bookingCalendar.acceptDelete', language))}
                                </button>
                                <button className="modal-btn-cancel" onClick={cancelDelete}>
                                    {(t('common.no', language))}
                                </button>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>

            <ToastNotifications language={language} />

        </>
    );
}

export default CalendarBooking;
